import { ContainerType } from '../../types';

import DeleteAllCardsModal from './Modals/DeleteAllCardsModal';
import DeleteCardModal from './Modals/DeleteCardModal';
import NewCardModal from './Modals/NewCardModal';

type OverlaysProps = {
  containerType: ContainerType;
};

const Overlays: React.FC<OverlaysProps> = ({ containerType }) => {
  return (
    <>
      <NewCardModal containerType={containerType} />
      <DeleteAllCardsModal />
      <DeleteCardModal />
    </>
  );
};

export default Overlays;
